import HeaderNav from './HeaderNav'
import HeaderNavItem from './HeaderNavItem'

const SponsorshipsNavHeader = (props) => (
    <HeaderNav>
        <HeaderNavItem location={`/organization/${props.organizationId}/event/${props.eventId}/participants`} label="Participants" />
        <HeaderNavItem location={`/organization/${props.organizationId}/event/${props.eventId}/participant/roles`} label="Participant Roles" />
        <HeaderNavItem location={`/organization/${props.organizationId}/event/${props.eventId}/sponsors`} label="Sponsors" />
    </HeaderNav>
)

export default SponsorshipsNavHeader;